module.exports = __webpack_public_path__ + "static/media/Graphic2.e510f9c0.png";